<template>
    <div class="task-tables">
        <!-- 头部查找 -->
        <div class="header">
            <!-- 搜索、 -->
            <div class="filter">
                <SearchControl :searchWidth="388" placeholder="搜索站点编号/钻孔ID/行政区划" @searchAction="searchAction"></SearchControl>
                <!-- 施工队 -->
                <el-select v-model="selectConstructionTeam" placeholder="全部施工队" @change="updateDrillDataList">
                    <el-option
                        v-for="team in constructionTeamList"
                        :key="team.id"
                        :label="team.deptName"
                        :value="team.id">
                    </el-option>
                </el-select>
                <!-- 施工状态 -->
                <el-select v-model="selectTaskStatus" placeholder="全部状态" @change="updateDrillDataList">
                    <el-option
                        v-for="status in taskStatusList"
                        :key="status.id"
                        :label="status.status"
                        :value="status.id">
                    </el-option>
                </el-select>
            </div>
            <!-- 导出 -->
            <DownloadExcel
                :data="selectZkArray"
                :export-fields="fieldsObj"
                name="钻孔数据.xls"
            >
                <button class="export" :class="{ disabled: selectZkArray.length == 0 }">导出</button>
            </DownloadExcel>
        </div>
        <!-- 列表 -->
        <div class="drill-list gq-table">
            <el-table
                ref="multipleTable"
                :data="zkList"
                tooltip-effect="dark"
                style="width: 100%"
                :border="true"
                :row-key="getRowKey"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="42"
                    fixed="left"
                    :reserve-selection="true"
                >
                </el-table-column>
                <!-- 站点编号 -->
                <el-table-column
                    label="站点编号"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdId }}</div>
                            <span class="single-show">{{ scope.row.zdId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 站点名称 -->
                <el-table-column
                    label="站点名称"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdName }}</div>
                            <span class="single-show">{{ scope.row.zdName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔ID -->
                <el-table-column
                    label="钻孔ID"
                    width="80"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkId }}</div>
                            <span class="single-show">{{ scope.row.zkId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 行政区划 -->
                <el-table-column
                    label="行政区划"
                    width="206"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</div>
                            <span class="single-show">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察经度 -->
                <el-table-column
                    label="钻孔勘察经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLon }}</div>
                            <span class="single-show">{{ scope.row.planLon }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察纬度 -->
                <el-table-column
                    label="钻孔勘察纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLat }}</div>
                            <span class="single-show">{{ scope.row.planLat }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 实际开孔经度 -->
                <el-table-column
                    label="实际开孔经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ getActualLon(scope.row) }}</div>
                            <span class="single-show">{{ getActualLon(scope.row) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 实际开孔纬度 -->
                <el-table-column
                    label="实际开孔纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ getActualLat(scope.row) }}</div>
                            <span class="single-show">{{ getActualLat(scope.row) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔深度 -->
                <el-table-column
                    label="钻孔深度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkHeight }}</div>
                            <span class="single-show">{{ scope.row.zkHeight }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 波速测试深度 -->
                <el-table-column
                    label="波速测试深度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.testHeight  }}</div>
                            <span class="single-show">{{ scope.row.testHeight  }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 施工队 -->
                <el-table-column
                    label="施工队"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.xgdName }}</div>
                            <span class="single-show">{{ scope.row.xgdName ? scope.row.xgdName : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 开孔日期 -->
                <el-table-column
                    label="开孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.startDate }}</div>
                            <span class="single-show">{{ scope.row.startDate ? scope.row.startDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 终孔日期 -->
                <el-table-column
                    label="终孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.endDate }}</div>
                            <span class="single-show">{{ scope.row.endDate ? scope.row.endDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 任务状态 -->
                <el-table-column
                    label="任务状态"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ judgeStatus(scope.row) }}</div>
                            <span class="single-show">{{ judgeStatus(scope.row) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 报告提交时间 -->
                <el-table-column
                    label="报告提交时间"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false" :disabled="!scope.row.docDate">
                            <div slot="content">{{ scope.row.docDate }}</div>
                            <span class="single-show">{{ scope.row.docDate ? scope.row.docDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--  -->
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <PaginationView :currentPage="pageNumber" :total="total"></PaginationView>
        </div>
    </div>
</template>
<script>
import PaginationView from '../../../../components/PaginationView.vue';
import SearchControl from '../../../../components/SearchControl.vue';
import { GetDrillDataList } from '@/http/api/api-hb'
export default {
    components: { SearchControl, PaginationView },
    props: {
        teamList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            // 施工单位对象
            deptInfo: null,
            // 钻孔列表
            zkList: [],
            // 选中的钻孔
            selectZkArray: [],
            fieldsObj: {
                '站点编号': 'zdId',
                '站点名称': 'zdName',
                '钻孔ID': 'zkId',
                '行政区划': 'address',
                '钻孔勘查经度': 'planLon',
                '钻孔勘查纬度': 'planLat',
                '实际开孔经度': 'realLon',
                '实际开孔纬度': 'realLat',
                '钻孔深度': 'zkHeight',
                '孔口高程': 'zkElevation',
                '施工队': 'xgdName',
                '开孔日期': 'startDate',
                '终孔日期': 'endDate',
                '任务状态': 'statusValue',
                '报告提交时间': 'docDate'
            },
            // 搜索关键字
            keywords: null,
            // 分页
            pageSize: 10,
            pageNumber: 1,
            // 总数
            total: 0,
            // 施工队列表
            constructionTeamList: [],
            // 选中施工队id
            selectConstructionTeam: 0,
            // 状态列表
            taskStatusList: [
                {
                    id: -1,
                    status: '全部'
                },
                {
                    id: 0,
                    status: '未开始'
                },
                {
                    id: 1,
                    status: '施工进行中'
                },
                {
                    id: 2,
                    status: '施工已完成'
                },
                {
                    id: 3,
                    status: '报告已提交'
                },
            ],
            // 选中的状态
            selectTaskStatus: -1
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.constructionTeamList = [{ id: 0, deptName: '全部施工队' }, ...this.teamList]
        })
        this.deptInfo = JSON.parse(localStorage.getItem('dept'))
        this.getDrillDataList()
    },
    methods: {
        // 获取钻孔列表
        getDrillDataList() {
            const params = {
                xgdwId: this.deptInfo.id,
                keyword: this.keywords,
                current: this.pageNumber,
                limit: this.pageSize
            }
            if (this.selectConstructionTeam != 0) {
                params.xgdId = this.selectConstructionTeam
            }
            if (this.selectTaskStatus != -1) {
                params.status = this.selectTaskStatus
            }
            GetDrillDataList(params).then(res => {
                if (res.code == 200) {
                    this.total = res.data.total
                    this.zkList = res.data.rows
                } else {
                    this.$message({ type: 'warning', message: res.msg })
                }
            })
        },
        // 搜索
        searchAction(keywords) {
            this.keywords = keywords
            this.updateDrillDataList()
        },
        // 更新钻孔列表数据
        updateDrillDataList() {
            this.pageNumber = 1
            this.getDrillDataList()
        },
        // 分页
        paginationRequestPage(page) {
            this.pageNumber = page
            this.getDrillDataList()
        },
        // 选中的数组
        handleSelectionChange(value) {
            this.selectZkArray = value.filter(zk => {
                zk.address = zk.province + zk.city + zk.county + zk.town
                if (zk.status == 0) {
                    zk.statusValue = '未开始'
                } else if (zk.status == 1) {
                    zk.statusValue = '进行中'
                } else if (zk.status == 2) {
                    zk.statusValue = '已完成'
                } else if (zk.status == 3) {
                    zk.statusValue = '报告已提交'
                }
                zk.realLon = this.getActualLon(zk)
                zk.realLat = this.getActualLat(zk)
                return zk
            })
        },
        // 判断数据状态
        judgeStatus(zk) {
            if (zk.status == 0) {
                return '未开始'
            } else if (zk.status == 1) {
                return '施工进行中'
            } else if (zk.status == 2) {
                return '施工已完成'
            } else if (zk.status == 3) {
                return '报告已提交'
            }
        },
        getRowKey(row) {
            return row.id + ''
        },
        // 获取实际经度
        getActualLon(data) {
            if (data.userInputLon) return data.userInputLon
            if (data.phoneLocationLon) return data.phoneLocationLon
            return '-'
        },
        // 获取实际纬度
        getActualLat(data) {
            if (data.userInputLat) return data.userInputLat
            if (data.phoneLocationLat) return data.phoneLocationLat
            return '-'
        },
    },
}
</script>
<style src="../../../../assets/css/gq_table.css" scoped></style>
<style scoped>
    .task-tables {
        width: 100%;
        height: calc(100% - 20px);
        padding-top: 20px;
    }
    /* 头部搜索 */
    .task-tables .header {
        width: calc(100% - 36px);
        height: 40px;
        padding: 0 18px;
        display: flex;
        justify-content: space-between;
    }
    .task-tables .header .export {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        background: #0054A0;
    }
    .task-tables .header .export.disabled {
        color: #CCCCCC;
        background: #F0F0F0;
    }
    .task-tables .header .filter {
        display: flex;
    }
    /* 选择框 */
    .task-tables .header /deep/ .el-select {
        width: 165px;
        height: 40px;
        background: #F4F4F4;
        border-radius: 6px;
        margin-right: 12px;
    }
    .task-tables .header /deep/ .el-select .el-input__inner {
        border: none;
        height: 40px;
        background: #F9F9F9;
        border-radius: 6px;
        border: none;
        font-size: 16px;
        color: #181818;
    }
    .task-tables .header /deep/ .el-select .el-input.is-focus .el-input__inner {
        border-radius: 10px;
        border: none;
    }
    .task-tables .drill-list {
        width: calc(100% - 36px);
        height: calc(100% - 108px);
        padding: 0 18px;
        margin-top: 20px;
        overflow: auto;
    }
    /* 分页 */
    .task-tables .pagination {
        width: 100%;
        height: 48px;
    }
</style>
